import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { UserPreferences } from '@contracts/index';

const initialState: UserPreferences = {
  enableWebGpu: true,
  vramBudgetMb: 2048,
  ramBudgetMb: 4096,
  opfsBudgetMb: 20480,
  preferredColormap: 'viridis',
  preferredUnits: 'SI',
  showCoordinateAxes: true
};

export const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    updatePreferences: (state, action: PayloadAction<Partial<UserPreferences>>) => {
      Object.assign(state, action.payload);
    },
    resetPreferences: () => initialState
  }
});

export const { updatePreferences, resetPreferences } = preferencesSlice.actions;

export default preferencesSlice.reducer;
